import type { PlayerTrendsResponse } from "@chessla/shared";
import { apiClient } from "@/shared/api/client";
import type { PerformanceQuery } from "@/features/performance-selection";

export const playerTrendsUrl = ({
  format,
  exactTimeControl,
  period = "all",
}: PerformanceQuery & { period?: string }): string => {
  const query = new URLSearchParams({ format, period });
  if (exactTimeControl) query.set("exactTimeControl", exactTimeControl);
  return `/trends?${query}`;
};

export const fetchPlayerTrends = (
  query: PerformanceQuery & { period?: string },
  signal?: AbortSignal,
): Promise<PlayerTrendsResponse> => apiClient<PlayerTrendsResponse>(playerTrendsUrl(query), { signal });
